import React from 'react';
import './Footer.style.scss';

const Footer = () => {
  return (
    <div className="footer">
      <span>Diego Quinteros - 2023</span>
    </div>
  );
};

export default React.memo(Footer);
